/**
 * Figma — "Executing Custom Test Case…" overlay (Run Once / Save & Execute).
 */
import { Box, Dialog, LinearProgress, Typography } from "@mui/material";
import { ReactComponent as ShieldIcon } from "../../asserts/logo/shield.svg";

export default function Gate2ExecutingCustomTestCaseDialog({ open, progress = 0 }) {
  const clamped = Math.min(100, Math.max(0, progress));

  return (
    <Dialog
      open={open}
      maxWidth={false}
      PaperProps={{
        sx: {
          m: 2,
          width: "100%",
          maxWidth: 480,
          borderRadius: "16px",
          overflow: "visible",
          bgcolor: "transparent",
          boxShadow: "none",
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            bgcolor: "rgba(255, 255, 255, 0.72)",
            backdropFilter: "blur(10px)",
          },
        },
      }}
    >
      <Box
        sx={{
          p: "1px",
          borderRadius: "16px",
          background: "linear-gradient(135deg, #005BF0 0%, #A855F7 45%, #005BF0 100%)",
        }}
      >
        <Box
          sx={{
            bgcolor: "#FFFFFF",
            borderRadius: "15px",
            px: 3,
            pt: 3.5,
            pb: 3,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 2.5 }}>
            <Box
              sx={{
                position: "relative",
                width: 88,
                height: 88,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  borderRadius: "50%",
                  border: "2px dashed #BFDBFE",
                  animation: "gate2CustomShieldSpin 14s linear infinite",
                  "@keyframes gate2CustomShieldSpin": {
                    from: { transform: "rotate(0deg)" },
                    to: { transform: "rotate(360deg)" },
                  },
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  inset: 10,
                  borderRadius: "50%",
                  border: "1px dashed #E9D5FF",
                  animation: "gate2CustomShieldSpinRev 20s linear infinite",
                  "@keyframes gate2CustomShieldSpinRev": {
                    from: { transform: "rotate(360deg)" },
                    to: { transform: "rotate(0deg)" },
                  },
                }}
              />
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: "50%",
                  bgcolor: "#EFF6FF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                  boxShadow: "0 2px 8px rgba(0, 91, 240, 0.12)",
                }}
              >
                <ShieldIcon style={{ width: 26, height: 26, stroke: "#005BF0" }} />
              </Box>
            </Box>

            <Typography
              sx={{
                fontFamily: "Lato, sans-serif",
                fontSize: 18,
                fontWeight: 700,
                lineHeight: "26px",
                color: "#0F172A",
                textAlign: "center",
                mb: 1.5,
              }}
            >
              Executing Custom Test Case…
            </Typography>

            <Typography
              sx={{
                fontFamily: "Lato, sans-serif",
                fontSize: 14,
                fontWeight: 400,
                lineHeight: "22px",
                color: "#64748B",
                textAlign: "center",
              }}
            >
              Running test case against linked metric…
            </Typography>
            <Typography
              sx={{
                fontFamily: "Lato, sans-serif",
                fontSize: 14,
                fontWeight: 400,
                lineHeight: "22px",
                color: "#64748B",
                textAlign: "center",
                mt: 0.25,
              }}
            >
              Sending prompt to LLM and evaluating response against ground truth.
            </Typography>
          </Box>

          <LinearProgress
            variant="determinate"
            value={clamped}
            sx={{
              height: 6,
              borderRadius: 3,
              bgcolor: "#E2E8F0",
              "& .MuiLinearProgress-bar": {
                borderRadius: 3,
                backgroundImage: "linear-gradient(90deg, #005BF0 0%, #7F2CE8 55%, #C026D3 100%)",
              },
            }}
          />
        </Box>
      </Box>
    </Dialog>
  );
}
